import { recommendClient } from '@algolia/recommend';
import type { RecommendClient } from '@algolia/recommend';
import { globals } from './globals';

let singletonClient: RecommendClient | null = null;
let clientAppId: string | undefined;
let clientApiKey: string | undefined;

export function getRecommendClient(): RecommendClient {
  const appId = globals.algoliaAppId;
  const apiKey = globals.algoliaSearchKey;

  if (singletonClient && clientAppId === appId && clientApiKey === apiKey) {
    return singletonClient;
  }

  singletonClient = recommendClient(appId, apiKey);
  clientAppId = appId;
  clientApiKey = apiKey;

  return singletonClient;
}

export function _resetForTesting(): void {
  singletonClient = null;
  clientAppId = undefined;
  clientApiKey = undefined;
}
